import React, { useState } from 'react'
import ModalLayout from "../../../layouts/modal";
import User from "../../../services/user";
import Flow from '../../../services/flow.service';
import PlansService from "../../../services/plans.service";
import Spinner from '../../../components/Spinners/Spinner';
import {removeDevicePlanParams} from "../../../services/vip.bundle.service"; 
import "./style.scss";

const EditDevicePopup = props => {

    const [loading, setLoading] = useState(false);

    const removeDevicePlan = () => { 
        setLoading(true);
        let params = removeDevicePlanParams();
        if (params){
          setLoading(true);
          let {plan_ids, product_code} = params;
          PlansService.saveBundlePlan(plan_ids, product_code).then(()=>{
            User.flowStatus().then((data)=>{
                PlansService.getSavedPlans().then(res => {})
            })
        }).finally(()=>{
          setLoading(false);
          props.close();
        })
        }
      }
  return (
    <ModalLayout
        close={()=>props.close()}
        title='Do you want to change your iPhone?'
        extras='device-addon-edit-options'>
            <div className='modal-container'> 
                <p className="device-addon-edit-desc">
                You can change the iPhone variant you chose or remove the iPhone entirely, to continue with your mobile plan only.
    What would you like to do?
                </p>
                <div className='device-addon-edit-options-ctas-wrapper'>
                    {loading? <Spinner size="small" />: 
                    <div className='device-addon-edit-options-ctas'>
                        <button onClick={removeDevicePlan}
                        className="vmo-button vmo-button-round vmo-button-wide vmo-button-white-bordered">
                            REMOVE PHONE
                        </button>
                        <button className="vmo-button vmo-button-round vmo-button-wide vmo-button-red"
                        onClick={()=>{
                            Flow.goTo('/choose-your-iphone')
                            props.close();
                        }}>
                        EDIT VARIANT
                        </button>
                    </div>}
                </div>
            </div>
        </ModalLayout>
  )
}

export default EditDevicePopup;